export default __webpack_public_path__ + "6fefa59bf3bba3031e3ec48a96cebaf4.png";